




import { Vue, Component, Prop, Emit, Model } from 'vue-property-decorator'
import { Tag as ITag } from '.'

@Component
export default class Tag extends Vue {
  @Prop({ type: Object, required: true }) preset!: ITag
  @Prop({ required: true }) data!: string

  get type() {
    return typeof this.preset.type === 'function'
      ? this.preset.type(this.data)
      : this.preset.type
  }
}
